export const colors = {
  bg: `var(--color-bg)`,
  node: `var(--color-node)`,
  link: `var(--color-link)`,
  highlight: `var(--color-highlight)`,
  bgLight: `var(--color-bg-light)`,
  textLight: `var(--color-text-light)`
};
